export interface RoastingSchedule {
  vendorKey: string;
  salesforceRecordId: string;
  roastingDays: (keyof typeof DaysOfTheWeek)[];
  timeZone: string;
  startTime: string;
  endTime: string; //cut off time
  updatedAt?: string;
}

export enum DaysOfTheWeek {
  "SUNDAY" = 7,
  "MONDAY" = 1,
  "TUESDAY" = 2,
  "WEDNESDAY" = 3,
  "THURSDAY" = 4,
  "FRIDAY" = 5,
  "SATURDAY" = 6,
}
